module.exports = __webpack_public_path__ + "img/image_001.14e84850.jpeg";